import { datadogLogs } from "@datadog/browser-logs";
import { DD_CLIENT_TOKEN } from "../constants";

datadogLogs.init({
  clientToken: DD_CLIENT_TOKEN,
  site: "datadoghq.eu",
  forwardErrorsToLogs: true,
  sampleRate: 100,
  service: "react-frontend",
});
